<template>
  <div class="side-panel">
    <div :class="{ 'overlay': true, 'animated': animated }" @click="onClose"></div>
    <div class="content">
      <div :class="{ 'inner-content': true, 'animated': animated }">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    onClose: {type: Function, default: function() { return }
    }
  },

  mounted() {
    setTimeout(function() {
      this.animated = true;
    }.bind(this), 10);
  },

  data() {
    return {
      animated: false
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@sass/_variables.scss';

  .side-panel {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;

    .overlay {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 400ms;

      &.animated {
        opacity: 1;
      }
    }

    .content {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
      min-width: 400px;
      margin-top: 0;

      .inner-content {
        position: absolute;
        background-color: $grey-light;
        padding: 70px;
        width: 100%;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        left: 100%;
        transition: left 400ms cubic-bezier(0.075, 0.82, 0.165, 1);

        &.animated {
          left: 0;
        }
      }
    }
  }
</style>
